import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export default function AdminMessagePopup({ message, onClose }) {
  if (!message) return null
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth slotProps={{ paper: { sx: { borderRadius: 2 } } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 700, fontSize: 15, pb: 1 }}>
        <InfoOutlinedIcon sx={{ color: 'primary.main', fontSize: 20 }} />
        Comunicado
      </DialogTitle>

      <DialogContent sx={{ pt: 0 }}>
        <Box
          component="div"
          sx={{
            fontSize: 13.5,
            lineHeight: 1.7,
            color: 'text.primary',
            '& strong': { fontWeight: 700 },
            '& em': { fontStyle: 'italic' },
            '& ul, & ol': { pl: 2.5, my: 0.5 },
            '& li': { mb: 0.25 },
          }}
          dangerouslySetInnerHTML={{ __html: message.content }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" size="small" sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 1.5 }}>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  )
}
